
  // document.addEventListener("DOMContentLoaded", function () {
  //   const targetElement = document.querySelector('html.sticky-header-enabled .shopify-section.header__outer-wrapper');
  //   function handleScrollStyles() {
  //     if (window.innerWidth <= 768) {
  //       if (window.scrollY > 70) {
  //         targetElement.style.backdropFilter = 'none';
  //         targetElement.style.background = '#fff';
  //       } else {
  //         targetElement.style.backdropFilter = 'blur(2px)';
  //         targetElement.style.background = 'rgba(255, 255, 255, 0.1)';
  //       }
  //     }
  //   }

  //   window.addEventListener('scroll', handleScrollStyles);
  // });

document.body.addEventListener("click", function (event) {

  if (event.target.closest(".css-1bk82ea")) {
      console.log('event target',event.target)
    const quickview = event.target.closest(".css-1uu22pi").querySelector(".css-14ska0w")
    quickview.click()
  }

});
// Delegate to handle any <a href="#upezBundleUpsell">
document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href="#upezBundleUpsell"]');
  if (!link) return;

  e.preventDefault();
  console.log('click event box');

  const target = document.querySelector('body #upezBundleUpsell');
  if (!target) return;

  // Compute target position minus 200px offset
  const targetTop =
    window.pageYOffset +
    target.getBoundingClientRect().top -
    200;

  // Smooth scroll (modern browsers)
  window.scrollTo({
    top: targetTop,
    behavior: 'smooth'
  });
});

  document.addEventListener('click', (e) => {
    const add = e.target.closest('.css-14ska0w');
   
    if (add)
{
     setTimeout(() => {
    const quickviewmodal = document.querySelector('.bb-quick-view-modal');
    if (!quickviewmodal) return;
    if (quickviewmodal.querySelector('.quick-view-close.X')) return;

    const item = document.createElement('div');
    item.className='stickyclose'
    item.innerHTML="<div class='quick-view-close X'>X</div>";
    quickviewmodal.prepend(item);
  }, 1200);
}

       if(e.target.classList.contains('quick-view-close')){
    const closebTn = e.target.closest('.css-1irezfp');
        closebTn.remove();
       }
  });
